import { render, staticRenderFns } from "./AccountProjectWaitingForReview.vue?vue&type=template&id=c7d7c458&"
import script from "./AccountProjectWaitingForReview.vue?vue&type=script&lang=ts&"
export * from "./AccountProjectWaitingForReview.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports